{
    "component-card-search-list.empty-state.title.non-final": "<strong>Vincular este repositorio a un componente de software</strong>",
    "component-card.add-chat-channel": "Añadir canal de chat",
    "component-card.chat-channels": "Canales de chat",
    "component-card.expander.show-more-link": "Mostrar {formattedCount} más"
}
